export default "__VITE_ASSET__f170545d__"